import { Box, useTheme } from '@primer/react';
import { SunIcon, MoonIcon } from '@primer/octicons-react';

function ThemeToggle() {
  const { colorMode, setColorMode } = useTheme();
  const isDark = colorMode === 'night';

  const toggle = () => setColorMode(isDark ? 'day' : 'night');

  return (
    <Box
      as="button"
      type="button"
      onClick={toggle}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      sx={{
        position: 'relative',
        width: '52px',
        height: '28px',
        padding: 0,
        borderRadius: '999px',
        border: '1px solid',
        borderColor: 'border.default',
        backgroundColor: 'neutral.muted',
        cursor: 'pointer',
        flexShrink: 0,
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '2px',
          left: '2px',
          width: '22px',
          height: '22px',
          borderRadius: '50%',
          backgroundColor: 'canvas.default',
          boxShadow: 'shadow.medium',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'fg.default',
          transform: isDark ? 'translateX(24px)' : 'translateX(0)',
          transition: 'transform 0.2s ease-in-out',
        }}
      >
        {isDark ? <MoonIcon size={14} /> : <SunIcon size={14} />}
      </Box>
    </Box>
  );
}

export default ThemeToggle;
